// extracted by mini-css-extract-plugin
export default {"amount":"AmountOrder_amount__qUS4W"};